import nvSharedServicesModule from '../../shared/services/nv.shared.services.module';
import { SdcActionsService } from './sdc-actions.service';
import { SdcStoreFactory } from './sdc-store.service';

// Since there are no @typings for flux-angular, need to override the angular typings here
// so that adding .store() doesn't throw TS errors
declare const angular;

export const SdcFluxModule = angular
  .module('SdcFluxModule', ['flux', 'nv.shared.services.sorter', nvSharedServicesModule, 'nv.sdcModule'])
  .service('sdcActions', SdcActionsService)
  .store('SDCStore', SdcStoreFactory).name;
